export default "__VITE_ASSET__78348839__"